import type { ReportQuery } from '../../services/report-query';

/** Recalculate the bounded UTC window when the registry loads, never freeze it in a widget file. */
export function period(duration: number): Pick<ReportQuery, 'from' | 'duration'> {
  const from = new Date();
  from.setUTCHours(0, 0, 0, 0);
  from.setUTCDate(from.getUTCDate() - duration + 1);
  return { from: from.toISOString(), duration };
}

/** Calendar year to date, including today, within the verifier's 366-day bound. */
export function yearToDate(): Pick<ReportQuery, 'from' | 'duration'> {
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const from = new Date(Date.UTC(today.getUTCFullYear(), 0, 1));
  return {from: from.toISOString(), duration: Math.round((today.getTime() - from.getTime()) / 86400000) + 1};
}
